module.exports = __webpack_public_path__ + "static/media/pulverizador2.7f8b6f30.svg";